export const dateCheck = {
  EXPIRED: 'expired',
  EXPIRING: 'expiring',  
  VALID: 'valid'
}
